import { render, staticRenderFns } from "./ContactLinkedin.vue?vue&type=template&id=97b3b804&scoped=true"
import script from "./ContactLinkedin.vue?vue&type=script&lang=js"
export * from "./ContactLinkedin.vue?vue&type=script&lang=js"
import style0 from "./ContactLinkedin.vue?vue&type=style&index=0&id=97b3b804&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97b3b804",
  null
  
)

export default component.exports